export default {
  HEADERSEPARATION_CONTAINER: 'HEADERSEPARATION_CONTAINER',
  SIMLEADERBOARD_CONTAINER: 'SIMLEADERBOARD_CONTAINER',
  SIMLEADERBOARD_CLICK: 'SIMLEADERBOARD_CLICK',
  SIMOBJECTIVES_CONTAINER: 'SIMOBJECTIVES_CONTAINER',
  SIMOBJECTIVES_CLICK: 'SIMOBJECTIVES_CLICK',
};
